import { REAL_ESTATE_TYPES, REAL_ESTATE_USAGES } from 'cpool-constants';
import { z } from 'zod';

import { Baubeschreibung } from './Baubeschreibung';
import { schemaApplicantAttributionBoth, schemaBigDecimal, schemaId, schemaInteger } from '../../utils/schema.utils';

export const Immobilie = z.object({
    baubeschreibung: Baubeschreibung.nullish().default(null),
    // TODO existiert nicht im europace schema - wofür ist das?
    baufinanzierungsrate: schemaBigDecimal.nullish().default(null),
    bezeichnung: z.string().nullish().default(null),
    darlehen: z
        .array(
            z.object({
                // TODO hier fehlt die id
                rateMonatlich: schemaBigDecimal.nullish().default(null),
                restschuld: schemaBigDecimal.nullish().default(null),
                zinsbindungBis: z.coerce.date().nullish().default(null),
            }),
        )
        .optional()
        .default([]),
    gehoertZuAntragsteller: schemaApplicantAttributionBoth,
    id: schemaId,
    immobilienart: z.nativeEnum(REAL_ESTATE_TYPES).nullish().default(null),
    mieteinnahmenKaltMonatlich: schemaBigDecimal.nullish().default(null),
    mieteinnahmenWarmMonatlich: schemaBigDecimal.nullish().default(null),
    nebenkostenMonatlich: schemaBigDecimal.nullish().default(null),
    nutzungsart: z.nativeEnum(REAL_ESTATE_USAGES).nullish().default(null),
    vermieteteWohnflaeche: z
        // we want to parse the value to an integer, but we need to check if the value is a number first
        .preprocess((val) => parseInt(Number(val) ? (val as string) : '', 10), schemaInteger)
        .nullish()
        .default(null),
    wert: schemaBigDecimal.nullish().default(null),
    wohnflaeche: z
        // we want to parse the value to an integer, but we need to check if the value is a number first
        .preprocess((val) => parseInt(Number(val) ? (val as string) : '', 10), schemaInteger)
        .nullish()
        .default(null),
});
export type Schema_Immobilie = z.infer<typeof Immobilie>;
export type Schema_Immobilie_Input = z.input<typeof Immobilie>;
// INFO yup schema
//                     yup.object().shape({
//                         baufinanzierungsrate: yup.number().optional().nullable().default(null),
//                         bezeichnung: yup.string().optional().nullable().default(null),
//                         darlehen: yup
//                             .array()
//                             .of(
//                                 yup.object().shape({
//                                     rateMonatlich: yup.number().optional().nullable().default(null),
//                                     restschuld: yup.number().optional().nullable().default(null),
//                                     zinsbindungBis: yup.date().optional().nullable().default(null),
//                                 }),
//                             )
//                             .default([]),
//                         gehoertZuAntragsteller: yup
//                             .string()
//                             .oneOf(['ANTRAGSTELLER_1', 'ANTRAGSTELLER_2', 'BEIDE'])
//                             .required(),
//                         id: yup.string(),
//                         immobilienart: yup
//                             .string()
//                             .oneOf([
//                                 'EIGENTUMSWOHNUNG',
//                                 'EINFAMILIENHAUS',
//                                 'MEHRFAMILIENHAUS',
//                                 'BUEROGEBAEUDE',
//                                 null,
//                             ])
//                             .optional()
//                             .nullable()
//                             .default(null),
//                         mieteinnahmenKaltMonatlich: yup.number().optional().nullable().default(null),
//                         mieteinnahmenWarmMonatlich: yup.number().optional().nullable().default(null),
//                         nebenkostenMonatlich: yup.number().optional().nullable().default(null),
//                         nutzungsart: yup
//                             .string()
//                             .oneOf(['EIGENGENUTZT', 'VERMIETET', 'EIGENGENUTZT_UND_VERMIETET', null])
//                             .optional()
//                             .nullable()
//                             .default(null),
//                         vermieteteWohnflaeche: yup.number().integer().optional().nullable().default(null),
//                         wert: yup.number().optional().nullable().default(null),
//                         wohnflaeche: yup.number().integer().optional().nullable().default(null),
//                     }),
